// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__d8c15f99dbd41d6bbdf2","cls2":"CreateSocialItem-cls2__cf4ac608a88ec193b8d0 CreateSocialItem-cls1__d8c15f99dbd41d6bbdf2"};